<template>
  <div v-if="showCounter" class="announcement-bar__counter сс">
      <p id="counter"></p>
  </div>
  <div class="announcement-bar">
    <div
      ref="announcements"
      class="announcement-bar__wrapper"
    >
      <div
        v-for="(announcement, index) in announcements"
        :key="announcement.id"
        :class="{
          [$class('minimised')]: state === 'hidden',
          [`announcement-bar__item--${announcement.settings.text_color}`]: announcement.settings.text_color
        }"
        :data-position="getPosition(index)"
        :style="{
          backgroundColor: announcement.settings.background
        }"
        class="announcement-bar__item body-2"
      >
        <div class="announcement-bar__item-inner">
          <eyebrow
            v-if="eyebrow"
            :enable-bullet="announcement.settings.eyebrow_bullet"
            :text="$cleanRTE(announcement.settings.evergreen_text)"
            class="announcement-bar__eyebrow"
          />
          <div
            v-else
            v-html="$cleanRTE(announcement.settings.announcement_text)"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: announcement-bar (announcement-bar)
 * -----------------------------------------------------------------------------
 * An announcement bar that rotates between messages.
 *
 * @param {Array} announcements - The messages to display and cycle through.
 * @param {Number} delay - The delay before starting and the pause duration
 * between animations.
 * @param {Boolean} eyebrow - Use eyebrow bullet styling.
 */

import { values as timings } from '~/config/timings'
import { getTranslateString, getTranslateX } from '~/helpers/general'

export default {
  name: 'AnnouncementBar',

  props: {
    announcements: {
      type: Array,
      default: () => [],
    },
    delay: {
      type: Number,
      default: 3,
    },
    showCounter: {
      type: Boolean,
      default: false,
    },
    endDate: {
      type: String,
      default: '',
    },
    endDateText: {
      type: String,
      default: '',
    },
    eyebrow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      duration: timings.m,
      global: true,
      state: 'visible',
      timeouts: [],
    }
  },

  mounted() {
    this.startLoop()
    this.countdown()
    document.addEventListener('visibilitychange', () => {
      const state = document.visibilityState
      this.state = state
      if (state === 'hidden') {
        this.stopLoop()
      } else if (state === 'visible') {
        this.startLoop()
      }
    })
  },

  methods: {

    countdown() {
      // Set the date we're counting down to
      var countDownDate = new Date(this.endDate).getTime();
      let endDateText = this.endDateText

      // Update the count down every 1 second
      var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"
        const counterEl =  document.getElementById("counter")
        if (counterEl) {
          counterEl.innerHTML = '<b>'+ endDateText +'</b> ' + days + "d " + hours + "h "
          + minutes + "m " + seconds + "s ";

          // If the count down is over, write some text
          if (distance < 0) {
            clearInterval(x);
            counterEl.innerHTML = "";
          }
        }
      }, 1000);
    },

    /**
     * Get the default position for the announcement to store as a data
     * attribute.
     * @param {Number} index - The index of the announcement in its array.
     * @returns {number}
     */
    getPosition(index) {
      if (index === 0) {
        return 100
      }
      else {
        return -1 * ((index - 1) * 100)
      }
    },

    /**
     * Start the infinite message cycle
     * @param {Number} index - The current slide index.
     */
    startLoop(index = 0) {
      if (this.announcements.length < 2) {
        return
      }
      const slides = this.$refs.announcements.children
      const nextIndex = index + 1
      const curr = slides[index]
      const next = nextIndex >= slides.length ? slides[0] : slides[nextIndex]
      const currPosition = curr.dataset.position

      this.timeouts[0] = setTimeout(() => {
        const currentX = getTranslateX(curr)
        const nextX = getTranslateX(next)
        next.style.zIndex = 1
        curr.style.transform = getTranslateString(currentX - 100)
        next.style.transform = getTranslateString(nextX - 100)

        this.timeouts[1] = setTimeout(() => {
          curr.style.zIndex = -1
          curr.style.transform = getTranslateString(currPosition)
        }, this.duration * 1000)

        this.startLoop(nextIndex < slides.length ? nextIndex : 0)
      }, this.delay * 1000)
    },

    stopLoop() {
      const slides = this.$refs.announcements.children
      this.timeouts.forEach(timeout => {
        if (timeout) {
          clearTimeout(timeout)
        }
      })
      this.timeouts = []

      if (slides && slides.forEach) {
        slides.forEach(slide => {
          slide.style.zIndex = ''
          slide.style.transform = ''
        })
      }
    },
  },
}
</script>
